import { useMemo } from 'react'

import { isLoveMailru } from 'common/constants'

import { usePartner } from './usePartner'

export const useLoveMailruPartner = (): boolean => {
  const { partnerId } = usePartner()

  return useMemo(() => isLoveMailru(partnerId), [partnerId])
}
